"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
/**
 * This is used for delivery filters in delivery options modal.
 */
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  /** Add a delivery method button in case of not selected delivery */
  TestId["AddDeliveryMethod"] = "AddDeliveryMethod";
  /** Rotated add icon in use as delete icon in address wrapper */
  TestId["AddIcon"] = "AddIcon";
  /** Wrapper for delivery additional info */
  TestId["AdditionalInfoBox"] = "additional-info-box";
  /** Add shipping offer button */
  TestId["AddOfferButton"] = "add-offer-button";
  /** Add new address button (flat delivery selection UI) */
  TestId["AddNewAddress"] = "add-new-address";
  /** Address form skeleton */
  TestId["AddressFormSkeleton"] = "address-form-skeleton";
  /** Address suggestions */
  TestId["AddressSuggestions"] = "address-suggestions";
  /** Wrapper for Azure map */
  TestId["AzureMapContainer"] = "azure-map-container";
  /** Wrapper for bing map */
  TestId["BingMapContainer"] = "bing-map-container";
  /** Courier box bounded to delivery address in delivery options with history filter active */
  TestId["BoundCourierBox"] = "bound-courier-box";
  /** Wrapper for shipping offer action buttons */
  TestId["ButtonsWrapper"] = "buttons-wrapper";
  /** Cancel button in address delete confirmation modal */
  TestId["CancelButton"] = "cancel-button";
  /** Clear icon */
  TestId["ClearIcon"] = "ClearIcon";
  /** Close icon of notification message */
  TestId["CloseIcon"] = "CloseIcon";
  /** Modal for confirmation of address delete */
  TestId["ConfirmDeleteAddressModal"] = "confirm-delete-address-modal";
  /** Continue button in simplified checkout for navigating from delivery selection to next section (billing address) */
  TestId["ContinueButton"] = "continue-button";
  /** Box for single courier */
  TestId["CourierBox"] = "courier-box";
  /** Courier fee */
  TestId["CourierFee"] = "courier-fee";
  /** Courier image */
  TestId["CourierImage"] = "courier-image";
  /** Wrapper for informations about courier */
  TestId["CourierInfo"] = "courier-info";
  /** Wrapper for informations about temporary disabled courier while data is loading */
  TestId["CourierInfoDisabled"] = "courier-info-disabled";
  /** Radio button for single courier in radio group */
  TestId["CourierRadioButton"] = "courier-radio-button";
  /** List of couriers with radio buttons */
  TestId["CourierSelection"] = "courier-selection";
  /** Delete confirmation button in address delete confirmation modal */
  TestId["DeleteButton"] = "delete-button";
  /** Delivery box as div which may be combined with boxName */
  TestId["DeliveryBox"] = "delivery-box";
  /** Wrapper for address info */
  TestId["DeliveryBoxAddressInfo"] = "delivery-box-address-info";
  /** Address name in delivery box */
  TestId["DeliveryBoxAddressName"] = "delivery-box-address-name";
  /** Wrapper for address info, image, edit and delete button and shipping offer */
  TestId["DeliveryBoxAddressWrapper"] = "delivery-box-address-wrapper";
  /** Delivery fee displayed on delivery box if delivery method is not home delivery */
  TestId["DeliveryBoxFee"] = "delivery-box-fee";
  /** Delivery box indicator indicates if delivery box is active */
  TestId["DeliveryBoxIndicator"] = "delivery-box-indicator";
  /** Clickable area for activating delivery box */
  TestId["DeliveryBoxLabel"] = "delivery-box-label";
  /** TextField for delivery comment */
  TestId["DeliveryCommentTextField"] = "delivery-comment-textfield";
  /** Delivery filter wrapper */
  TestId["DeliveryFilter"] = "delivery-filter";
  /** Delivery filter address wrapper */
  TestId["DeliveryFilterAddress"] = "delivery-filter-address";
  /** Delivery filter empty select */
  TestId["DeliveryFilterEmptySelect"] = "delivery-filter-empty-select";
  /** Delivery filter history wrapper */
  TestId["DeliveryFilterHistory"] = "delivery-filter-history";
  /** IconButton delivery filter popup / list */
  TestId["DeliveryFilterPopup"] = "delivery-filter-popup";
  /** Delivery method tag */
  TestId["DeliveryMethodTag"] = "delivery-method-tag";
  /** Backdrop overlay with loading icon for delivery options dialog */
  TestId["DeliveryOptionsComponentLoading"] = "delivery-options-component-loading";
  /** Delivery options header with filter */
  TestId["DeliveryOptionsHeader"] = "delivery-options-header";
  /** Wrapper for content in delivery options modal with it's own scroll via ScopedCssBaseline */
  TestId["DeliveryOptionsModalContent"] = "delivery-options-modal-content";
  /** Collapsed non-editable view of flat delivery selection UI */
  TestId["DeliverySummary"] = "delivery-summary";
  /** Skeleton for loading state of collapsed flat delivery selection UI */
  TestId["DeliverySummarySkeleton"] = "delivery-summary-skeleton";
  /** Text item for delivery telephone number */
  TestId["DeliveryTelephoneNumber"] = "delivery-telephone-number";
  /** Toggle for switching history and addresses */
  TestId["DeliveryToggleHistoryAddress"] = "delivery-toggle-history-address";
  /** Text item for working hours of pickup points */
  TestId["DeliveryWorkingHours"] = "delivery-working-hours";
  /** Address form dialog loading overlay */
  TestId["DialogLoadingOverlayAddressForm"] = "dialog-loading-overlay-address-form";
  /** Azure pickup points loading overlay */
  TestId["DialogLoadingOverlayAzurePickupPoints"] = "dialog-loading-overlay-azure-pickup-points";
  /** Confirm delete address dialog loading overlay */
  TestId["DialogLoadingOverlayConfirmDeleteAddress"] = "dialog-loading-overlay-confirm-delete-address";
  /** Find pickup points dialog loading overlay */
  TestId["DialogLoadingOverlayFindPickupPoints"] = "dialog-loading-overlay-find-pickup-points";
  /** Instant results dialog loading overlay */
  TestId["DialogLoadingOverlayInstantResult"] = "dialog-loading-overlay-instant-result";
  /** Map dialog loading overlay */
  TestId["DialogLoadingOverlayMap"] = "dialog-loading-overlay-map";
  /** Map factory dialog loading overlay */
  TestId["DialogLoadingOverlayMapFactory"] = "dialog-loading-overlay-map-factory";
  /** Pickup points dialog content loading overlay */
  TestId["DialogLoadingOverlayPickupPointsDialogContent"] = "dialog-loading-overlay-pickup-points-dialog-content";
  /** Pickup points list dialog loading overlay */
  TestId["DialogLoadingOverlayPickupPointsList"] = "dialog-loading-overlay-pickup-points-list";
  /** Pickup points map dialog loading overlay */
  TestId["DialogLoadingOverlayPickupPointsMap"] = "dialog-loading-overlay-pickup-points-map";
  /** Primary address location dialog loading overlay */
  TestId["DialogLoadingOverlayPrimaryAddressLocation"] = "dialog-loading-overlay-primary-address-location";
  /** Address list of addresses without any suggestions */
  TestId["EmptyAddresses"] = "empty-addresses";
  /** History list of addresses and pickup points without any suggestions */
  TestId["EmptyHistory"] = "empty-history";
  /** No shipping offer text */
  TestId["EmptyShippingOffersText"] = "no-shipping-offer-text";
  /** Estimated delivery */
  TestId["EstimatedDelivery"] = "estimated-delivery";
  /** Find box component for main delivery in case no valid delivery is provided */
  TestId["FindBox"] = "find-box";
  /** Find pickup point button in delivery options */
  TestId["FindPickupPoint"] = "find-pickup-point";
  /** Find pickup points dialog */
  TestId["FindPickupPointsDialog"] = "find-pickup-points-dialog";
  /** Google marker */
  TestId["GoogleMarker"] = "google-marker";
  /** Wrapper for google map */
  TestId["GoogleMapContainer"] = "google-map-container";
  /** Highlighted phrase of pickup point value when search is performed in instant results */
  TestId["HighlightedPhrase"] = "highlighted-phrase";
  /** History suggestions */
  TestId["HistorySuggestions"] = "history-suggestions";
  /** Home delivery button (flat delivery selection UI)  */
  TestId["HomeDeliveryMethodButton"] = "home-delivery-method-button";
  /** Delivery method icon for home delivery */
  TestId["HomeIcon"] = "HomeIcon";
  /** Delivery method icon for home delivery */
  TestId["CheckoutDelivery"] = "checkout-delivery";
  /** Instant result container */
  TestId["InstantResultContainer"] = "instant-result-container";
  /** Instant result row in list view */
  TestId["InstantResultListRow"] = "instant-result-list-row";
  /** Instant results row in map view */
  TestId["InstantResultMapRow"] = "instant-result-map-row";
  /** Skeleton for instant results */
  TestId["InstantResultSkeleton"] = "instant-result-skeleton";
  /** Description for shipping offer item */
  TestId["ItemDescription"] = "item-description";
  /** Shipping offer image wrapper */
  TestId["ItemImage"] = "item-image";
  /**
   * Load more pickup points button in case there is more possible pickup points than configured page size
   * PICKUP_POINTS_PAGE_SIZE in '../constants'
   */
  TestId["LoadMorePickupPoints"] = "load-more-pickup-points";
  /**
   * Load more suggestions button in case there is more possible suggestions than configured page size
   * SUGGESTIONS_PAGE_SIZE in '../constants'
   */
  TestId["LoadMoreSuggestions"] = "load-more-suggestions";
  /** Map container */
  TestId["MapContainer"] = "map-container";
  /** Map preview unavailable notification after selection pickup point without coordinates */
  TestId["MapPreviewUnavailableNotification"] = "map-preview-unavailable-notification";
  /** Text item for message to the courier */
  TestId["MessageToTheCourier"] = "message-to-the-courier";
  /** Nearest pickup points container */
  TestId["NearestPickupPointsContainer"] = "nearest-pickup-points-container";
  /** Skeleton for nearest pickup points */
  TestId["NearestPickupPointsSkeleton"] = "nearest-pickup-points-skeleton";
  /** Wrapper for new delivery address button and find pickup point button in delivery options */
  TestId["NewDelivery"] = "new-delivery";
  /** Search term used in pickup points and diplayed in no results message */
  TestId["NoResultsSearchTerm"] = "no-results-search-term";
  /** Alert wrapper for notification message */
  TestId["NotificationMessage"] = "notification-message";
  /** Link inside notification message alert */
  TestId["NotificationMessageLink"] = "notification-message-link";
  /** Out of stock flag in delivery box for tooltip activation about out of stock items */
  TestId["OosFlag"] = "oos-flag";
  /** Default delivery method icon */
  TestId["OriflameIcon"] = "OriflameIcon";
  /** Original courier fee before discount displayed on courier box if delivery method is home delivery */
  TestId["OriginalCourierFee"] = "original-courier-fee";
  /** Original delivery fee before discount displayed on delivery box if delivery method is not home delivery */
  TestId["OriginalDeliveryBoxFee"] = "original-delivery-box-fee";
  /** Pen icon in use as edit icon in address wrapper */
  TestId["PenIcon"] = "PenIcon";
  /** Pickup delivery button (flat delivery selection UI)  */
  TestId["PickupDeliveryMethodButton"] = "pickup-delivery-method-button";
  /** Pickup point card */
  TestId["PickupPointCard"] = "pickup-point-card";
  /** Pickup point cards list */
  TestId["PickupPointCards"] = "pickup-point-cards";
  /** Pickup point card availability */
  TestId["PickupPointCardAvailability"] = "pickup-point-card-availability";
  /** Pickup point card price */
  TestId["PickupPointCardPrice"] = "pickup-point-card-price";
  /** Pickup point card skeleton */
  TestId["PickupPointCardSkeleton"] = "pickup-point-card-skeleton";
  /** Instant result pickup point's property to be displayed (Description, CvId, Street, ...) */
  TestId["PickupPointInstruction"] = "pickup-point-instruction";
  /** Wrapper for pickup point list pages */
  TestId["PickupPointsListContainer"] = "pickup-points-list-container";
  /** Pickup points list page */
  TestId["PickupPointsListPage"] = "pickup-points-list-page";
  /** Pickup points list tab */
  TestId["PickupPointsListTab"] = "pickup-points-list-tab";
  /** Pickup points map tab */
  TestId["PickupPointsMapTab"] = "pickup-points-map-tab";
  /** Pickup points search clear button */
  TestId["SearchClearButton"] = "search-clear-button";
  /** Search field container */
  TestId["SearchFieldContainer"] = "search-field-container";
  /** Search icon */
  TestId["SearchIcon"] = "SearchIcon";
  /** Input element in the search field */
  TestId["SearchInput"] = "search-input";
  /** Indicator icon if shipping offer item is selected */
  TestId["SelectedIcon"] = "selected-icon";
  /** Select pickup point button - small or big version (flat delivery selection UI)  */
  TestId["SelectPickupPointButton"] = "select-pickup-point-button";
  /** Confirm button in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialoConfirmButton"] = "select-pickup-point-dialog-confirm-button";
  /** Select pickup dialog in delivery options */
  TestId["SelectPickupPointDialog"] = "select-pickup-point-dialog";
  /** Current location button in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialogCurrentLocationButton"] = "select-pickup-point-dialog-current-location-button";
  /** Left menu in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialogLeftMenu"] = "select-pickup-point-dialog-left-menu";
  /** Map in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialogMap"] = "select-pickup-point-dialog-map";
  /** Search field in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialogSearch"] = "select-pickup-point-dialog-search";
  /** Zoom buttons in select pickup point dialog in delivery options */
  TestId["SelectPickupPointDialogZoomButtons"] = "select-pickup-point-dialog-zoom-buttons";
  /** Shipping fee */
  TestId["ShippingFee"] = "shipping-fee";
  /** Shipping offer banner */
  TestId["ShippingOffer"] = "shipping-offer";
  /** Shipping offer icon for tooltip activation */
  TestId["ShippingOfferIcon"] = "shipping-offer-icon";
  /** Shipping offer icon which is temporary disabled while data is loading */
  TestId["ShippingOfferIconDisabled"] = "shipping-offer-icon-disabled";
  /** Single shipping offer item which may be combined with product code */
  TestId["ShippingOfferItem"] = "shipping-offer-item";
  /** Skeleton for shipping offer item */
  TestId["ShippingOfferItemSkeleton"] = "shipping-offer-item-skeleton";
  /** Shipping offer modal window */
  TestId["ShippingOfferModal"] = "shipping-offer-modal";
  /** Content of shipping offer modal */
  TestId["ShippingOfferModalContent"] = "shipping-offer-modal-content";
  /** Backdrop overlay with loading icon for shipping offer modal */
  TestId["ShippingOfferModalLoading"] = "shipping-offer-modal-loading";
  /** Skeleton for single shipping offer */
  TestId["ShippingOfferSkeleton"] = "shipping-offer-skeleton";
  /** Skeleton for courier box component */
  TestId["SkeletonCourierBox"] = "skeleton-courier-box";
  /** Skeleton for delivery box component */
  TestId["SkeletonDeliveryBox"] = "skeleton-delivery-box";
  /** Skeleton for delivery options dialog component */
  TestId["SkeletonDeliveryOptions"] = "skeleton-delivery-options";
  /** Skeleton for pickup points list */
  TestId["SkeletonPickupPointsList"] = "skeleton-pickup-points-list";
  /** Suggestion wrapper for suggestion pages of active filter in delivery options */
  TestId["Suggestions"] = "suggestions";
  /** Suggestion page for list of delivery boxes in delivery options */
  TestId["SuggestionsPage"] = "suggestions-page";
  /** Wrapper for yandex map */
  TestId["YandexMapContainer"] = "yandex-map-container";
  return TestId;
}({});